import {useMutation, useQueryClient} from '@tanstack/react-query';
import {
  removeRecruitmentFromRecruitmentsCache,
  type RecruitmentCacheSnapshot,
} from '@/utils/cache-updaters/recruitments';
import recruitmentsFetchers from '@/api/fetchers/recruitments';
import {RemoveRecruitmentParams} from '@/views/creators/recruit-crm/types';
import {recruitmentsQueryKey} from '@/hooks/queries/use-recruitments-query';

function useRemoveRecruitment() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: [recruitmentsQueryKey, 'remove'],
    mutationFn: recruitmentsFetchers.remove,
    onMutate: (variables: RemoveRecruitmentParams) => {
      return removeRecruitmentFromRecruitmentsCache({
        agencyId: variables.agencyId,
        recruitmentId: variables.recruitmentId,
      });
    },
    onError: (
      _err,
      _variables,
      context: RecruitmentCacheSnapshot[] | undefined
    ) => {
      if (context) {
        context.forEach(({queryKey, previousData}) => {
          queryClient.setQueryData(queryKey, previousData);
        });
      }
    },
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: [recruitmentsQueryKey]});
    },
  });
}

export default useRemoveRecruitment;
